import { useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { DimensionVariantImage } from '../dimension_management/DimensionOptions'

export interface SavedImage {
    url: string
    width: number
    height: number
    timestamp: number
    id: string
    dimensionVariants?: Record<string, DimensionVariantImage>
    mainDimensionId?: string
}

interface SaveImageOptions {
    onSave?: (image: SavedImage) => void
}

export const useSaveImage = ({ onSave }: SaveImageOptions = {}) => {
    const saveImage = useCallback((imageData: {
        url: string
        width: number
        height: number
        dimensionVariants?: Record<string, DimensionVariantImage>
        mainDimensionId?: string
        id?: string
    }) => {
        const timestamp = Date.now()
        const id = imageData.id ?? uuidv4()

        const savedImage: SavedImage = {
            ...imageData,
            timestamp,
            id
        }

        onSave?.(savedImage)
        return savedImage
    }, [onSave])

    return {
        saveImage
    }
}
